import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { Masks } from "react-native-mask-input";
import { XStack } from "tamagui";
import { z } from "zod";

import { useUpdateUserProfile } from "@/api/mutations/userProfile";
import { useGetUserProfile } from "@/api/queries/userProfile";
import { MaskedInput } from "@/components";
import SkipOrSubmit from "@/conversation/AskUserQuestionsPanel/SkipOrSubmit";
import { dateOfBirthZodString } from "@/forms/ProfileForm";

const dateOfBirthSchema = z.object({
  dateOfBirth: dateOfBirthZodString,
});

type DateOfBirthForm = z.infer<typeof dateOfBirthSchema>;

export default function DateOfBirthStep({
  onSubmitted,
}: {
  onSubmitted: () => void;
}) {
  const { data: profile } = useGetUserProfile();
  const { mutate: updateUserProfile, isPending } = useUpdateUserProfile();

  const { control, handleSubmit } = useForm<DateOfBirthForm>({
    resolver: zodResolver(dateOfBirthSchema),
    mode: "onBlur",
    values: { dateOfBirth: profile?.dateOfBirth ?? "" },
  });

  const onSubmit = handleSubmit(({ dateOfBirth }) => {
    updateUserProfile({ data: { dateOfBirth } }, { onSuccess: onSubmitted });
  });

  return (
    <>
      <Controller
        control={control}
        name="dateOfBirth"
        render={({ field: { onChange, onBlur, value }, fieldState }) => (
          <MaskedInput.Controlled
            label="Date of birth"
            mask={Masks.DATE_MMDDYYYY}
            placeholder="mm/dd/yyyy"
            inputMode="numeric"
            value={value}
            onChangeText={onChange}
            onBlur={onBlur}
            errorText={fieldState.error?.message}
            rootProps={{ paddingHorizontal: "$150" }}
          />
        )}
      />
      <XStack
        justifyContent="flex-end"
        paddingHorizontal="$150"
        marginTop="$250"
        paddingBottom="$150"
      >
        <SkipOrSubmit
          showSkip={false}
          showSubmit
          submitDisabled={isPending}
          isLast
          onSkip={onSubmit}
          onSubmit={onSubmit}
        />
      </XStack>
    </>
  );
}
